import { map, Observable, of, tap } from 'rxjs'
import { CanvasService } from '../canvas.service'
import { CanvasArgs, CanvasBaseCommand, CanvasCommandType } from './canvas-command.model'

export type DeleteCanvasArgs = CanvasArgs

export class DeleteCanvasCommand extends CanvasBaseCommand<DeleteCanvasArgs> {
  readonly id = 'delete'
  readonly type: CanvasCommandType = 'invoker'
  override icon = 'delete_outline'
  override label = 'Delete'
  override tooltip = 'Delete canvas'
  override readonly color = '#cf554d'

  constructor(canvasService: CanvasService) {
    super(canvasService)
  }

  override enabled(args?: DeleteCanvasArgs): boolean {
    return !!args?.canvasId
  }

  protected doExecute(args?: DeleteCanvasArgs): Observable<boolean> {
    if (!args?.canvasId) return of(false)

    return this.canvasService.delete_canvas(args.canvasId).pipe(
      tap(res => this.emitResult({ success: res.success, data: args.canvasId })),
      map(res => res.success),
    )
  }
}
